<template>
  <div id="app">
    <router-view v-if="isRouterAlive" class="page"></router-view>
  </div>
</template>
<script>
export default {
  name: "app",
  provide() {
    return {
      reloadPage: this.reloadPage,
    };
  },
  data: function () {
    return {
      isRouterAlive: true,
    };
  },
  methods: {
    reloadPage: function () {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>

<style>
@import "./assets/css/main.css";
@import "./assets/css/color-dark.css"; /*深色主题*/
/*@import "./assets/css/theme-green/color-green.css";   浅绿色主题*/
</style>